export default {"src":"/_next/static/media/next-swiper-say.d5baaae7.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};